import { render } from "./FloatBackPage.vue?vue&type=template&id=dbea3d8c"
import script from "./FloatBackPage.vue?vue&type=script&lang=js"
export * from "./FloatBackPage.vue?vue&type=script&lang=js"

import "./FloatBackPage.vue?vue&type=style&index=0&id=dbea3d8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__